define('view/disclosure/disclosure.list.document.action.buttons',['require','exports','module','fukit','uikit/uikit','./disclosure.download','blockit'],function (require, exports, module) {
    //prettier-ignore
    var TooltipBehavior         = require('fukit').TooltipBehavior,
        UIKit                   = require('uikit/uikit'),
        DisclosureDownload = require('./disclosure.download');
        BlocKit                 = require('blockit');

    var DisclosureListDocumentActionButtons = UIKit.ItemView.extend({
        template: function () {
            return '<ui name="fileButtonView" />';
        },


        internalViewOptions: {

            fileButtonView: function () {

                return {
                    type: UIKit.Button.extend({
                        className: UIKit.Button.prototype.className + ' minimal',
                    }),
                    icon: 'download',
                    iconRight: true,
                    floated: true,
                    color: 'primary',
                    model: this.model,

                    behaviors: {
                        hideWhenEditMode: {
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                            optionValues: {
                                visible: {
                                    formatter: function (model) {
                                        var docs = model.get('documents');
                                        return (docs && docs.length  > 0 );
                                    },
                                },
                            },
                        },

                        TooltipBehavior: {
                            on: 'focus',
                            hideOnScroll: true,
                            exclusive: true,
                            content: {
                                type: DisclosureDownload,
                                model: this.model,
                            },
                            behaviorClass: TooltipBehavior,
                        },
                    },
                };
            },
        },

    });
    module.exports = DisclosureListDocumentActionButtons;
});

